import { Box, Card, IconButton, Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Close, List } from "@mui/icons-material";
import { COLORS } from "../../../ui/Theme";
import { ListDivider } from "../../../ui/ListStyles";
import { useRoiPersonalWatchContext } from "../../../context/roi/personal-watch/RoiPersonalWatchContext";

const roiPeriodData = [
  { label: "هفتگی", value: "weekly_roi" },
  { label: "ماهانه", value: "monthly_roi" },
  { label: "سه ماهه", value: "quarterly_roi" },
  { label: "شش ماهه", value: "half_yearly_roi" },
  { label: "سالانه", value: "yearly_roi" },
  { label: "سه ساله", value: "three_years_roi" },
];

const Typography = styled("p")({
  fontSize: "12px",
  direction: "rtl",
});

const Row = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderRadius: "4px",
  padding: "4px 6px",
});

const RoiPersonalWatchCard = ({ data }) => {
  const { setIsDeleteModal, setSelectedWatch, setIsStocksModal } =
    useRoiPersonalWatchContext();

  const handleShowStocks = () => {
    setSelectedWatch({
      id: data.industrial_group_id,
      name: data.industrial_group_name,
    });
    setIsStocksModal(true);
  };

  const handleDelete = () => {
    setIsDeleteModal(true);
    setSelectedWatch({
      id: data.industrial_group_id,
      name: data.industrial_group_name,
    });
  };

  return (
    <Card sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Tooltip title={data.industrial_group_name}>
          <Typography
            sx={{
              fontWeight: 700,
              textAlign: "center",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              direction: "ltr",
            }}
          >
            {data.industrial_group_name}
          </Typography>
        </Tooltip>

        <IconButton
          onClick={handleDelete}
          disableRipple
          size="small"
          sx={{ p: 0 }}
        >
          <Close sx={{ color: COLORS.RED, width: "18px" }} />
        </IconButton>
      </Box>

      <ListDivider flexItem />

      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        {roiPeriodData.map((item) => (
          <Row
            key={item.value}
            sx={{
              bgcolor:
                data[item.value] > 0
                  ? COLORS.SOFTGREEN
                  : data[item.value] === 0
                  ? "inherit"
                  : COLORS.SOFTRED,
            }}
          >
            <Typography>{item.label}</Typography>
            <Typography
              sx={{
                color:
                  data[item.value] > 0
                    ? COLORS.GREEN
                    : data[item.value] === 0
                    ? "inherit"
                    : COLORS.RED,
                fontWeight: "700",
              }}
            >
              {data[item.value]}%
            </Typography>
          </Row>
        ))}
      </Box>
      <button
        onClick={handleShowStocks}
        className="btn"
        style={{ fontWeight: 400 }}
      >
          سهم‌ها
      </button>
    </Card>
  );
};

export default RoiPersonalWatchCard;
